import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Title,
  Link,
  CurrentPageTitle,
  Breadcrumb,
} from 'styles/components/SubHeader';

const SubHeader = ({ title, links, currentPageTitle }) => (
  <Container>
    <Title>{title}</Title>
    <Breadcrumb aria-label='breadcrumb'>
      {links?.map((link, index) => (
        <Link key={`breadcrumbLink${index}`} to={link.to}>
          {link.title}
        </Link>
      ))}
      <CurrentPageTitle>{currentPageTitle}</CurrentPageTitle>
    </Breadcrumb>
  </Container>
);

SubHeader.propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
  currentPageTitle: PropTypes.string,
};

export default SubHeader;
